import { FC } from "react";
import { useHotkeys } from "../../../hotkey";
import { Badge } from "../../Badge";
import { CloseButton } from "../../CloseButton";
import { useTableContext, useTablePropsContext } from "../context";

import styles from "./styles.module.scss";

export const BulkActions: FC = (() => {
  const table = useTableContext();
  const { bulkActions } = useTablePropsContext();

  const selectedRowCount = table.getSelectedRowCount();

  useHotkeys("esc", () => {
    table.resetRowSelection();
  }, { enabled: !!selectedRowCount, enableOnFormTags: true });

  if (!selectedRowCount) {
    return null;
  }

  return (
    <div className={styles.root}>

      <div className={styles.content}>
        <Badge
          badgeSize="md"
          badgeColor="brand"
          badgeType="badgeColor"
        >
          {selectedRowCount} selected
        </Badge>
        <div className={styles.divider} />
        {bulkActions}
        <CloseButton
          onClick={() => table.resetRowSelection()}
        />
      </div>
    </div>
  );
});